/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import {ReactComponent as Search} from "../assets/img/icons/search-check.svg";
import {ReactComponent as ArrowRight} from "../assets/img/icons/arrow-right-white.svg";
import Make from "../assets/img/filters/make.svg";
import Model from "../assets/img/filters/model.svg";
import Year from "../assets/img/filters/year.svg";
import Fuel from "../assets/img/carBox/gas-station.svg";
import City from "../assets/img/filters/city.svg";
import useAxiosJTW from "../Hooks/useAxiosJTW";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const FiltersCars = (props) => {

    let params = useParams();
    const axiosJWT = useAxiosJTW();

    const [activeFilters, setActiveFilters] = useState([]);

    const { t, i18n } = useTranslation();

    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [years, setYears] = useState([]);
    const [fuels, setFuels] = useState([]);
    const [cities, setCities] = useState([]);

    const [selectedMake, setSelectedMake] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedFuel, setSelectedFuel] = useState('');
    const [selectedCity, setSelectedCity] = useState('');

    const getAllMakes = ( signal) => {
        const _merchantid = params.merchantid ? params.merchantid : 0;
        axiosJWT.post('api/getallmakes', {'merchant_id': _merchantid, 'has_ads': '1', 'filter' : '1'}, {signal}).then( (response) => {
            if(response.status === 200){
                if( response.data.makes ){
                    setMakes(response.data.makes);
                }
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    const getModelByMake = (data) => {
        axiosJWT.post('api/getmodelsbymake', { make_id: data }).then( (response) => {
            if(response.status === 200){
                if( response.data.models ){
                    setModels(response.data.models);
                }
            }
        } ).catch((error) => {
            console.log(error);
        });
    }
    const getyearsbymodel  = (data) => {
        axiosJWT.post('api/getyearsbymodel ', { model: data }).then( (response) => {
            if(response.status === 200){
                if( response.data.years ){
                    setYears(response.data.years);
                }
            }
        } ).catch((error) => {
            console.log(error);
        });
    }
    const getfuel  = (data) => {
        axiosJWT.post('api/getfuel ', data).then( (response) => {
            if(response.status === 200){
                if( response.data ){
                    setFuels(response.data);
                }
            }
        } ).catch((error) => {
            console.log(error);
        });
    }
    const getcitiesbyfilter  = (data) => {
        axiosJWT.post('api/getcitiesbyfilter ', data).then( (response) => {
            if(response.status === 200){
                if( response.data.cities ){
                    setCities(response.data.cities);
                }
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getAllMakes( signal);

        return () => {controller.abort();}
    }, [params]);

    const onMakeSelect = (value) =>{
        setSelectedMake(value);

        setSelectedModel('');
        setSelectedYear('');
        setSelectedFuel('');
        setSelectedCity('');

        setYears([]);
        setFuels([]);
        setCities([]);

        getModelByMake(value);
    }
    const onModelSelect = (value) =>{
        setSelectedModel(value);

        setSelectedYear('');
        setSelectedFuel('');
        setSelectedCity('');

        setFuels([]);
        setCities([]);

        getyearsbymodel (value);
    }
    const onYearSelect = (value) =>{
        setSelectedYear(value);

        setSelectedFuel('');
        setSelectedCity('');

        setCities([]);

        const data = {
            make_id : selectedMake,
            model_name : selectedModel,
            years : value,
        }
        getfuel(data);
    }
    const onFuelSelect = (value) =>{
        setSelectedFuel(value);

        setSelectedCity('');

        const data = {
            make_id : selectedMake,
            model_name : selectedModel,
            years : selectedYear,
            fuel : value
        }
        getcitiesbyfilter(data);
    }
    const onCitySelect = (value) =>{
        setSelectedCity(value);
    }

    const onReset = () =>{
        setSelectedMake('');
        setSelectedModel('');
        setSelectedYear('');
        setSelectedFuel('');
        setSelectedCity('');

        setModels([]);
        setYears([]);
        setFuels([]);
        setCities([]);

        const data = {
            make_id : '',
            model_name : '',
            years : '',
            fuel : '',
            city : ''
        }
        props.onReset(data);
    }
    const onSubmit = () =>{
        const data = {
            make_id : selectedMake,
            model_name : selectedModel,
            years : selectedYear,
            fuel : selectedFuel,
            city : selectedCity
        }
        props.onSubmit(data);
    }

    return (
        <>
            <div className='filters-title'>
                <div className='filters-title__icon'>
                    <Search/>
                </div>
                <div className='filters-title__content'>
                    <div className='filters-title__label'>{t('dismantlers.findAds')}</div>
                    {/*<div className='filters-title__text'>Search 26,673 Vehicles</div>*/}
                </div>
            </div>

            <div className='filters-reset-all' onClick={onReset} >
                {/*<div className='activeFilters'>*/}

                {/*    <div className='activeFilters__item' >vag</div>*/}

                {/*</div>*/}
                { (selectedMake != '' || selectedModel != '' || selectedYear != '' || selectedCity != '' ) && <div className='reset-all'>{t('fields.Reset')}</div>}
            </div>

            <div className='filters'>
                <div className='filter-select'>
                    <div className='filter-select__header'>
                        <div className='icon-link pt-0 pb-2'>
                            <div className='icon-link__icon'><img src={Make} alt='Make'/> </div>
                            <div htmlFor='filterMake' className='icon-link__text text--title'>{t('fields.selectMake' )}</div>
                        </div>
                    </div>
                    <select className='form-control' value={selectedMake} onChange={ (e) =>{ onMakeSelect(e.target.value)} }>
                        <option value="">{t('fields.Select' )}</option>
                        { makes.map( (make, index2) => {
                            if(parseInt(make.count) > 0 ){
                                return(
                                    <option value={make.make_id} key={index2}>{make.title}</option>
                                )
                            }
                        } ) }

                    </select>
                </div>
                <div className='filter-select'>
                    <div className='filter-select__header'>
                        <div className='icon-link pt-0 pb-2'>
                            <div className='icon-link__icon'><img src={Model} alt='Model'/> </div>
                            <div className='icon-link__text text--title'>{t('fields.selectModel')}</div>
                        </div>
                    </div>
                    <select className='form-control' value={selectedModel} onChange={ (e) =>{ onModelSelect(e.target.value )} }>
                        <option value="">{t('fields.Select' )}</option>
                        { models.map( (item, index) => (
                            <option value={item.model_name} key={index}>{item.model_name}</option>
                        ) ) }
                    </select>
                </div>
                <div className='filter-select'>
                    <div className='filter-select__header'>
                        <div className='icon-link pt-0 pb-2'>
                            <div className='icon-link__icon'><img src={Year} alt='Year'/> </div>
                            <div className='icon-link__text text--title'>{t('fields.selectYear')}</div>
                        </div>
                    </div>
                    <select className='form-control' value={selectedYear} onChange={ (e) =>{ onYearSelect(e.target.value)} }>
                        <option value="">{t('fields.Select' )}</option>
                        { years.map( (item, index) => (
                            <option value={item.model_year} key={index}>{item.model_year}</option>
                        ) ) }
                    </select>
                </div>
                <div className='filter-select'>
                    <div className='filter-select__header'>
                        <div className='icon-link pt-0 pb-2'>
                            <div className='icon-link__icon'><img src={Fuel} alt='Fuel'/> </div>
                            <div className='icon-link__text text--title'>{t('fields.Fuel')}</div>
                        </div>
                    </div>
                    <select className='form-control' value={selectedFuel} onChange={ (e) =>{ onFuelSelect(e.target.value)} }>
                        <option value="">{t('fields.Select' )}</option>
                        { fuels.map( (item, index) => (
                            <option value={item.fuel_type_id} key={index}>{item.title}</option>
                        ) ) }
                    </select>
                </div>
                <div className='filter-select filter-select--city'>
                    <div className='filter-select__header'>
                        <div className='icon-link pt-0 pb-2'>
                            <div className='icon-link__icon'><img src={City} alt='City'/> </div>
                            <div className='icon-link__text text--title'>{t('fields.SelectCity')}</div>
                        </div>
                    </div>
                    <select className='form-control' value={selectedCity} onChange={ (e) =>{onCitySelect(e.target.value)} }>
                        <option value="">{t('fields.Select' )}</option>
                        { cities.map( (item, index) => (
                            <option value={item.id} key={index}>{item.description}</option>
                        ) ) }
                    </select>
                </div>
                {/*<FiltersSelect/>*/}
                <button className='btn btn-primary btn-icon btn-icon-right btn-block mt-5' onClick={onSubmit} disabled={selectedMake === '' || selectedModel === ''}>{t('fields.Submit')} <ArrowRight/></button>
            </div>
        </>
    );
};

FiltersCars.defaultProps = {
    isDismantler: false,
    makes: [],
    models: [],
    years: [],
    city: [],
    selectedMake: ''
};

export default FiltersCars;
